(function () {
  document.querySelectorAll('[data-product-spotlight]').forEach(function (root) {
    var dataEl = root.querySelector('[data-spotlight-json]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var variants = data.variants;
    var selected = {};

    var pillGroups = Array.prototype.slice.call(root.querySelectorAll('[data-spotlight-group]'));
    var priceEl = root.querySelector('[data-spotlight-price]');
    var compareEl = root.querySelector('[data-spotlight-compare]');
    var qtyInput = root.querySelector('[data-spotlight-qty]');
    var qtyMinus = root.querySelector('[data-spotlight-qty-minus]');
    var qtyPlus = root.querySelector('[data-spotlight-qty-plus]');
    var addBtn = root.querySelector('[data-spotlight-add]');
    var buyBtn = root.querySelector('[data-spotlight-buy]');
    var statusEl = root.querySelector('[data-spotlight-status]');

    function formatMoney(cents) {
      return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: data.currency || 'GBP' });
    }

    function findVariant() {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return selected[i] === opt;
        });
      });
    }

    function updateUI() {
      var variant = findVariant();
      if (!variant) return;
      priceEl.textContent = formatMoney(variant.price);
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
      var available = variant.available;
      addBtn.disabled = !available;
      buyBtn.disabled = !available;
      addBtn.textContent = available ? 'Add to cart' : 'Sold out';
    }

    pillGroups.forEach(function (group) {
      var index = parseInt(group.getAttribute('data-spotlight-group'), 10);
      var pills = group.querySelectorAll('[data-spotlight-pill]');
      pills.forEach(function (pill) {
        if (pill.classList.contains('active')) {
          selected[index] = pill.getAttribute('data-spotlight-pill');
        }
        pill.addEventListener('click', function () {
          if (pill.classList.contains('unavailable')) return;
          pills.forEach(function (p) { p.classList.remove('active'); });
          pill.classList.add('active');
          selected[index] = pill.getAttribute('data-spotlight-pill');
          updateUI();
        });
      });
    });

    if (qtyMinus) {
      qtyMinus.addEventListener('click', function () {
        var val = Math.max(1, parseInt(qtyInput.value, 10) - 1);
        qtyInput.value = val;
      });
    }
    if (qtyPlus) {
      qtyPlus.addEventListener('click', function () {
        var val = Math.max(1, parseInt(qtyInput.value, 10) + 1);
        qtyInput.value = val;
      });
    }

    function addToCart(redirectTo) {
      var variant = findVariant();
      if (!variant) return;
      var qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      statusEl.textContent = 'Adding…';
      addBtn.disabled = true;
      buyBtn.disabled = true;

      if (redirectTo) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variant.id, quantity: qty }] })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Add to cart failed');
            window.location.href = redirectTo;
          })
          .catch(function () {
            statusEl.textContent = 'Something went wrong — try again';
            addBtn.disabled = false;
            buyBtn.disabled = false;
          });
        return;
      }

      var afterAdd = function () {
        statusEl.textContent = '✓ Added to cart';
        addBtn.disabled = false;
        buyBtn.disabled = false;
      };

      if (window.UKPSCart && window.UKPSCart.addToCart) {
        window.UKPSCart.addToCart(variant.id, qty).then(afterAdd).catch(function () {
          statusEl.textContent = 'Something went wrong — try again';
          addBtn.disabled = false;
          buyBtn.disabled = false;
        });
        return;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variant.id, quantity: qty }] })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(afterAdd)
        .catch(function () {
          statusEl.textContent = 'Something went wrong — try again';
          addBtn.disabled = false;
          buyBtn.disabled = false;
        });
    }

    if (addBtn) {
      addBtn.addEventListener('click', function () { addToCart(null); });
    }
    if (buyBtn) {
      buyBtn.addEventListener('click', function () { addToCart('/checkout'); });
    }

    updateUI();
  });
})();
